import { type AccountManager } from "../types";

// Mock data for account managers
const mockAccountManagers: AccountManager[] = [
  // Account 1 managers
  {
    id: "1",
    accountId: "1",
    email: "admin@acme.com",
    name: "John Doe",
    status: "accepted",
    invitedAt: new Date("2024-01-10"),
    acceptedAt: new Date("2024-01-12"),
    createdAt: new Date("2024-01-10").toISOString(),
    updatedAt: new Date("2024-01-12").toISOString(),
  },
  {
    id: "2",
    accountId: "1",
    email: "manager@acme.com",
    name: "Jane Smith",
    status: "accepted",
    invitedAt: new Date("2024-02-15"),
    acceptedAt: new Date("2024-02-16"),
    createdAt: new Date("2024-02-15").toISOString(),
    updatedAt: new Date("2024-02-16").toISOString(),
  },
  {
    id: "3",
    accountId: "1",
    email: "pending@acme.com",
    status: "pending",
    invitedAt: new Date("2024-03-01"),
    createdAt: new Date("2024-03-01").toISOString(),
    updatedAt: new Date("2024-03-01").toISOString(),
  },
  // Account 2 managers
  {
    id: "4",
    accountId: "2",
    email: "admin@techsolutions.com",
    name: "Mike Johnson",
    status: "accepted",
    invitedAt: new Date("2024-02-20"),
    acceptedAt: new Date("2024-02-21"),
    createdAt: new Date("2024-02-20").toISOString(),
    updatedAt: new Date("2024-02-21").toISOString(),
  },
  // Account 3 managers
  {
    id: "5",
    accountId: "3",
    email: "admin@global.com",
    name: "Sarah Williams",
    status: "accepted",
    invitedAt: new Date("2024-03-10"),
    acceptedAt: new Date("2024-03-11"),
    createdAt: new Date("2024-03-10").toISOString(),
    updatedAt: new Date("2024-03-11").toISOString(),
  },
];

class AccountManagerService {
  async getAccountManagers(accountId: string): Promise<AccountManager[]> {
    return new Promise((resolve) => {
      setTimeout(() => {
        const managers = mockAccountManagers.filter((m) => m.accountId === accountId);
        resolve([...managers]);
      }, 300);
    });
  }

  async inviteAccountManager(accountId: string, email: string): Promise<AccountManager> {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newManager: AccountManager = {
          id: crypto.randomUUID(),
          accountId,
          email,
          status: "pending",
          invitedAt: new Date(),
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        };
        mockAccountManagers.push(newManager);
        resolve(newManager);
      }, 500);
    });
  }
}

export const accountManagerApi = new AccountManagerService();
